export const SMALL_VIEW_PORT = '576px';
export const MEDIUM_VIEW_PORT = '768px';
export const LARGE_VIEW_PORT = '992px';
export const CONTAINER_MAX_WIDTH = '1170px';
export const PRIMARY_COLOR = '#fb251b';
export const SECONDARY_COLOR = '#9093c3';
